import { motion } from "framer-motion";

export default function GgkSection() {
  return (
    <section className="relative py-24 lg:py-32 border-y border-[#D4AF37]/20 bg-[#0d0c0a] overflow-hidden" data-testid="ggk-section">
      <span className="pointer-events-none select-none absolute -bottom-10 right-0 font-display text-[26vw] leading-none uppercase text-[#D4AF37]/[0.03] whitespace-nowrap">
        Fight Club
      </span>
      <div className="max-w-7xl mx-auto px-4 sm:px-8 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center relative">
        <motion.div
          initial={{ opacity: 0, scale: 0.92 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="lg:col-span-5 flex justify-center"
        >
          <div className="relative border border-zinc-800 bg-black overflow-hidden">
            <div className="absolute inset-0 border border-[#D4AF37]/30 translate-x-2 translate-y-2 -z-10" />
            <img
              src="/images/ggk-fightclub.jpeg"
              alt="GGK Fight Club — official artwork"
              className="w-full max-w-md object-contain"
              data-testid="ggk-logo-image"
            />
          </div>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, delay: 0.1, ease: [0.16, 1, 0.3, 1] }}
          className="lg:col-span-7"
        >
          <p className="font-mono2 text-[10px] sm:text-xs tracking-[0.4em] text-[#D4AF37] uppercase mb-4 flex items-center gap-4">
            <span className="h-px w-10 bg-[#D4AF37]" /> The Powerhouse
          </p>
          <h2 className="font-display text-5xl sm:text-6xl lg:text-7xl uppercase leading-[0.9] text-white">
            Powered by <span className="text-[#D4AF37]">GGK Fight Club</span>
          </h2>
          <p className="mt-6 text-base sm:text-lg text-zinc-300 leading-relaxed max-w-2xl" data-testid="ggk-description">
            Masters Pro Boxing is powered by <span className="text-white font-medium">GGK Fight Club</span> —
            the promotion and training force behind the masters division. From fighter development and
            conditioning camps to fight-night promotion, GGK builds veterans into championship-ready athletes.
          </p>
          <div className="mt-8 flex flex-wrap gap-6 font-mono2 text-[10px] sm:text-xs tracking-[0.25em] uppercase text-zinc-500">
            <span data-testid="ggk-point-1" className="flex items-center gap-2"><span className="h-1.5 w-1.5 rotate-45 bg-[#D4AF37]" /> Fighter Development</span>
            <span data-testid="ggk-point-2" className="flex items-center gap-2"><span className="h-1.5 w-1.5 rotate-45 bg-[#D4AF37]" /> Event Promotion</span>
            <span data-testid="ggk-point-3" className="flex items-center gap-2"><span className="h-1.5 w-1.5 rotate-45 bg-[#D4AF37]" /> Training & Conditioning</span>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
